
















































    import {Vue, Component, Prop, Watch} from 'vue-property-decorator';

    import { Controller} from "../plugins/Controller";

    import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
    import Loader from '@/components/Common/Loader.vue'
	import Contacts from '@/components/PageSections/Contacts.vue';
	import { BannerData} from "@/models/BannerData";
	import SolarPage from '@/components/Solar/SolarPage.vue';
	import SoftwarePage from "@/components/Software/SoftwarePage.vue";
	import ContactsPage from "@/components/Contacts/ContactsPage.vue";
	import ClientsPage from "@/components/ClientsPage/ClientsPage.vue";
	import AIISCUEPage from "@/components/Software/AIISCUEPage.vue";
	import DoubleTrPage from '@/components/SubstationPage/DoubleTrPage.vue';
	import SingleTrPage from '@/components/SubstationPage/SingleTrPage.vue';

    import {
        Heading,
        Bold,
        Underline,
        Italic,
        OrderedList,
        BulletList,
        Link,
        HardBreak,
        Blockquote,
        CodeBlock,
        ListItem,
        TodoItem,
        TodoList,
        Code,
        Strike,
        Image,
        Focus,
        History,
        Table,
        TableHeader,
        TableCell,
        TableRow,
	} from 'tiptap-extensions';
    import VacancyPage from "@/components/VacancyPage/VacancyPage.vue";
    import DistributionPointPage from "@/components/SubstationPage/DistributionPointPage.vue";
    import DoubleLevelTrPage from "@/components/SubstationPage/DoubleLevelTrPage.vue";
    import SandwitchTr from "@/components/SubstationPage/sandwitchTr.vue";

    @Component({
        components: {
            SandwitchTr,
            DoubleLevelTrPage,
            DistributionPointPage,
            VacancyPage,
            SolarPage,
            SoftwarePage,
            ContactsPage,
            EditorContent,
            Loader,
			Contacts,
            ClientsPage,
			AIISCUEPage,
            DoubleTrPage,
            SingleTrPage,
        }
    })
    export default class PageViewer extends Vue{
        @Prop()
        identifier: string;

        private editor: Editor = new Editor();
        private content: string = "";
        private header: string = "";
        private loading: boolean = false;
        private bannerData:  BannerData = new BannerData("", "", "");

        controller: Controller = new Controller();

        mounted(){
            this.editor = new Editor({
                editable: false,
                extensions: [
                    new Blockquote(),
                    new BulletList(),
                    new CodeBlock(),
                    new HardBreak(),
                    new Heading({ levels: [1, 2, 3] }),
                    new ListItem(),
                    new OrderedList(),
                    new TodoItem(),
                    new TodoList(),
                    new Link(),
                    new Bold(),
                    new Code(),
                    new Italic(),
                    new Strike(),
                    new Underline(),
                    new Table({
                        resizable: true,
                    }),
                    new TableHeader(),
                    new TableCell(),
                    new TableRow(),
                    new Image(),
                    new History(),
                ],
            });
        }

        @Watch("identifier", { immediate: true })
        getPage(){
            if(!!this.identifier){
                if(this.identifier == 'about'){
                    this.$router.push({name: 'Home'});
				}

                this.loading = true;
                this.controller.GetPageByName(this.identifier)
                    .then(this.gotPage)
                    .catch((error) => { console.log(error); this.$router.push("/notFound"); this.loading = false;});
            }
		}

        gotPage(response: any){
            let responseValue = response.data?.value;
            if(responseValue){
                this.header = responseValue.header;
                this.content = responseValue.content;
                this.editor.setContent(JSON.parse(this.content));

                this.bannerData = new BannerData(responseValue.bannerImage, responseValue.bannerText, responseValue.bannerLink);

                document.title = `${this.header} - ООО "КУРС"`
            }
            this.loading = false;
        }

    }
